import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@zhfe/common-library'
import { ReportService } from '@/services/report.service'

export interface RequestParams {
  /** 渠道标识 */
  chan: string
}

export interface RequestParamsAd {
  pos_code: string
}

export interface PriPackages {
  /** 套餐id */
  id: number
  /** 标价，精确到分 */
  price: number
  /** 折扣价，精确到分 */
  discount_price: number
  /** 执行价，精确到分 */
  real_price: number
  /** 套餐名称 */
  name: string
  /** 具体说明 */
  detail: string
  /** 提示(角标) */
  tips: string
  /** 拓展字段 */
  ext_arr: string
}

export interface ResponseData {
  pri_packages: PriPackages[]
}

export interface Items {
  /** 图片 */
  img?: string
  /** 排序号 */
  order_num?: number
  /** 文字 */
  title?: string
  /** 链接 */
  url?: string
}

export interface List {
  /** 广告类型：0-全部，1-图文，2-文字，3-轮播 */
  ad_type: string
  /** 产品形态：web, clent, ... */
  client_type: string
  /** 方案代号 */
  plan: string
  /** 方案权重 */
  weight: number
  /** 广告项 */
  items: Items[]
}

export interface ResponseDataAd {
  /** 广告方案列表 */
  list?: List[]
}

export interface RequestParamsPay {
  /** 支付的APP，由服务端分配 */
  payapp: string
  /** 付费产品ID，预先配置好 */
  product_id: string
  /** 微信openid */
  openid: string
  /** 见备注 */
  client_extra?: string
}

export interface WxResp {
  /** （调起支付相关参数） */
  prepayid: string
  /** （调起支付相关参数） */
  appid: string
  /** （调起支付相关参数） */
  noncestr: string
  /** （调起支付相关参数） */
  timestamp: string
  /** （调起支付相关参数） */
  sign: string
  /** （调起支付相关参数） */
  sign_type: string
  /** （调起支付相关参数） */
  package: string
}

export interface ResponseDataPay {
  /** 预订单ID，全局唯一，以后查询也用这个ID */
  order_id: string
  /** 金额，单位分 */
  fee: number
  /** 过期时间，客户端只能在这个时间之前支付 */
  expires: string
  /** 微信调起支付需要的参数 */
  wx_resp: WxResp
  /** 货币，默认CNY */
  fee_type?: string
}

export interface RequestParamsPrepare {
  /** 业务类型：1-套餐，2-素材 */
  biztype: number
  /** 支付类型：1-微信QR支付，2-支付宝 */
  paytype: number
  /** 套餐id，素材id */
  id: number
  /** 来源 */
  source: string
}

export interface ResponseDataPrapre {
  /** 用于支付产品id */
  product_id: string
}

export interface RequestParamsPackageCount {
  pos_code: string
}

export interface ResponseDataPackageCount {
  /** 剩余个数 */
  count: number
}

@Injectable()
export class PayService {
  constructor(private http: Http, private report: ReportService) {}

  reportPay(params) {
    const dat = 'duba_office_wxpay:7802 actiontype:string uid:string source:string order_id:string order_num:string ver:string ext:string'
    this.report.webReport(params, dat)
  }

  showWxPay(params, onSuccess) {
    function onBridgeReady() {
      // @ts-ignore
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        params,
        function (res) {
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            onSuccess()
          }
      })
    }
    // @ts-ignore
    if (typeof WeixinJSBridge == 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
        // @ts-ignore
      } else if (document.attachEvent) {
          // @ts-ignore
          document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
          // @ts-ignore
          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
       }
    } else {
      onBridgeReady()
    }
  }

  getApiRechargePrepare (params: RequestParamsPrepare) {
    return this.http.post<ResponseDataPrapre>('/recharge/prepare', params)
  }

  getAdConfig(params: RequestParamsAd) {
    return this.http.post<ResponseDataAd>('/ad/list', params).then(res => res.list[0]?.items[0])
  }

  getIsShowInterval() {
    const show = '1'
    return this.getAdConfig({ pos_code: 'wx_permanent_countdown' }).then(res => res?.title === show)
  }

  palceWxPayOrder (params: RequestParamsPay) {
    return this.http.post<ResponseDataPay>('/payv2/wx/jsapi', params)
  }

  getTipForever() {
    return this.getAdConfig({ pos_code: 'wx_permanent_recommend' }).then(res => res?.title || '')
  }

  getPackages(params: RequestParams) {
    return this.http.post<ResponseData>('/recharge/packages', params).then((packageList: ResponseData) => {
      const l = packageList.pri_packages
      return l.map(item => this.clean(item))
    })
  }

  getPackageCount(params: RequestParamsPackageCount) {
    return this.http.post<ResponseDataPackageCount>('/ad/package/count', params).then((res: ResponseDataPackageCount) => res.count)
  }

  usePackage(params: RequestParamsPackageCount) {
    return this.http.post('/ad/used_package/add', params)
  }

  clean (packageItem: PriPackages) {
    return {
      id: packageItem.id,
      name: packageItem.name,
      priceOriginal: this.toPriceYuan(packageItem.price),
      priceReal: this.toPriceYuan(packageItem.real_price),
      tipFooter: packageItem.tips
    }
  }

  // 处理为单位元，服务端的单位为分
  toPriceYuan (priceMinute) {
    return priceMinute / 100
  }
}
